<template>
    <div :class="['quantityInput showtooltip', textError ? 'has-error' : '']">
        <input type="text"
        class="form-control text-right"
        :disabled="disabledSteps.customer"
        placeholder="E.g. 1.00"
        v-model="valueInput"
        @mousedown.prevent
        @click="onFocus"
        @focusin="onFocus"
        @input="onQtyInput"
        @blur="onQtyBlur"
        @change="isInterger"
        />
        <span class="tooltip" v-if="textError">{{ textError }}</span>
    </div>
</template>
<script>
export default {
    name: "quantityInput",
    props: {
        disabledSteps: {
            type: Object,
            required: true,
        },
        valueProp: {
            type: [String, Number],
            required: true,
        },
        numMax: {
            type: [String, Number],
            required: false,
            default: 999999.99,
        },
        numMin: {
            type: [String, Number],
            required: false,
            default: 0.01,
        },
        maxLength: {
            type: [String, Number],
            required: false,
            default: 12,
        }
    },
    data() {
        return {
            textError: null,
            valueInputValid: this.valueProp,
            valueInput: this.valueProp,
            isEditing: false,
            valueMaxSup: null,
        };
    },
    methods : {
        onFocus(e) {
            this.isEditing = true; // Activar modo edición
            setTimeout(() => {
                let rawValue = e.target.value;
                rawValue = rawValue.replace(/[$,]/g, "");
                e.target.value = rawValue;
                this.$nextTick(() => e.target.select());
            }, 0);
        },
        onQtyInput(e) {
            let val = e.target.value;
            // 1️⃣ Retener solo números y un punto
            val = val.replace(/[^0-9.]/g, "");
            // 2️⃣ Evitar múltiples puntos
            const firstDot = val.indexOf(".");
            if (firstDot !== -1) {
                // Remover puntos adicionales
                val =
                val.substring(0, firstDot + 1) +
                val.substring(firstDot + 1).replace(/\./g, "");
            }
            // 3️⃣ SIEMPRE que haya más de 2 decimales → redondear
            if (firstDot !== -1) {
                const decimals = val.substring(firstDot + 1);
                if (decimals.length > 2) {
                const num = Number(val);
                val = num.toFixed(2); // ⬅️ Redondeo real SIEMPRE
                }
            }
            // 4️⃣ Autocorrección suave de longitud
            if (val.length > this.maxLength) {
                val = val.slice(0, this.maxLength);
            }
            e.target.value = val;
            this.valueInputValid = val;
            this.textError = null;
        },
        onQtyBlur(e) {
            let val = e.target.value;
            if (!val || isNaN(val)) {
            this.valueInputValid = "0.00";
            return;
            }
            val = parseFloat(val);
            // validar min
            if (val < this.numMin) {
                this.textError = "Min value is "+ this.numMin;
                val = this.numMin;
            }
            // validar max
            if (val > this.numMax) {
                this.valueMaxSup = val;
                this.textError = "Max value is "+ this.numMax +", "+ this.valueMaxSup.toFixed(2) +" exceeded.";
                val = this.numMax;
            }
            e.target.value = val.toFixed(2);
            this.valueInputValid = val.toFixed(2);
        },
        isEmptyNaN(val) {
            if (isNaN(val)) { return true; }
            else if (val == null) { return true; }
            else if (val == '') { return true; }
            else { return false; }
        },
        isInterger(e) {
            let t = this;
            let val = e.target.value;
            // 1️⃣ Revisar vacío/NaN
            if (this.isEmptyNaN(val)) {
                e.target.value = "0.00";
                this.valueInputValid = "0.00";
                return;
            }
            // 2️⃣ Limpiar comas o caracteres raros antes del parse
            val = val.replace(/[^0-9.]/g, ""); // solo números y punto
            // 3️⃣ Si hay múltiples puntos → eliminar los extras
            const firstDot = val.indexOf(".");
            if (firstDot !== -1) {
                val =
                    val.substring(0, firstDot + 1) +
                    val.substring(firstDot + 1).replace(/\./g, "");
            }
            // 4️⃣ Convertir y REDONDEAR SIEMPRE a 2 decimales
            let num = Number(val);
            if (isNaN(num)) {
                num = 0;
            }
            // 5️⃣ Redondeo real
            val = num.toFixed(2);
            // 6️⃣ Formato final con separador de miles
            const formatted = val
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, "");
            // Asignar al input
            e.target.value = formatted;
            this.valueInputValid = formatted;
        },
    },
    watch: {
        valueInputValid(newVal) {
            this.$emit("input", newVal);
        },
        valueProp(newVal) {
            this.valueInput = newVal;
            this.valueInputValid = newVal;
        },
    },
}
</script>
